import { useEffect } from "react";
import { formatCurrencyBRL, maskCurrencyBRL, maskDate } from "../../../utils/mask/MaskUtils";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { colorNegative, colorPositive } from "../../../theme";
import { AnuncioStatus } from "../components/AnuncioItemCard";
import { AnunciosShopkeeper } from "../dto/ShopkeeperDTO";

export function useAutoScroll(
  ref: React.RefObject<HTMLDivElement>,
  enabled: boolean,
  speed = 0.3
) {
  useEffect(() => {
    if (!enabled || !ref.current) return;

    let animationId: number;

    const scroll = () => {
      if (!ref.current) return;

      ref.current.scrollLeft += speed;

      if (
        ref.current.scrollLeft + ref.current.clientWidth >=
        ref.current.scrollWidth
      ) {
        ref.current.scrollLeft = 0;
      }

      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationId);
  }, [enabled, speed, ref]);
}


export const lidarComTipoVeiculo = (tipo: string, date: string, status: string) => {
  if (status ==='1') {
    return 'Anúncio vendido';
  }
  if(status ==='2') return 'Anúncio Encerrado';
  if (tipo === null || date === null) return '';
  if (tipo === 'L') {
    return `Leilão encerra em: ${format(new Date(date), "dd/MM/yyyy - HH:mm", { locale: ptBR })}`;
  }

  return `Finaliza em: ${format(new Date(date), "dd/MM/yyyy - HH:mm", { locale: ptBR })}`;
};
export const encerramentoAnúncio = (tipo: string, date: string) => {
  if (tipo === null || date === null) return '';
  if (tipo === 'L') {
    return `${format(new Date(date), "dd/MM/yyyy - HH:mm", { locale: ptBR })}`;
  }

  return `${format(new Date(date), "dd/MM/yyyy - HH:mm", { locale: ptBR })}`;
};


export const lidarComValorInicialOrValoProposta = (val_inicial: number, maior_proposta?: number) => {
  if (maior_proposta === undefined && maior_proposta === null) {
    return '';
  }
  if (maior_proposta!== undefined && maior_proposta !== null) {
    return formatCurrencyBRL(maior_proposta);
  }
  return formatCurrencyBRL(val_inicial);
};

export function subtractDays(date: Date, days: number) {
  const result = new Date(date);
  result.setHours(result.getHours() - days);
  return result;
}

export const getStatusBgColor = (status: AnuncioStatus): string => {
  switch (status) {
    case "L":
      return colorNegative;
    case "C":
      return "rgb(254, 102, 0)";
    case "P":
      return "rgb(0, 99, 247)";
    case "N":
      return colorPositive;
    default:
      return "rgba(107, 117, 136, 0.12)";
  }
};

export const getStatusLabel = (status: AnuncioStatus): string => {
  switch (status) {
    case "N":
      return "Compre agora";
    case "L":
      return "Leilão";
    case "C":
      return "Cotação";
    case "P":
      return "Pacote";
  }
};

export function getDataLimiteAnuncio(anuncio: AnunciosShopkeeper): Date {
  if (anuncio.tipo_anuncio === "L") {
    return new Date(anuncio.data_leilao);
  }

  // N ou C
  return new Date(anuncio.data_finalizacao);
}


export interface CountdownResult {
  expired: boolean;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalMs: number;
}

export function calcularCountdown(
  currentDateISO: string,
  dataLimite: Date
): CountdownResult {
  const now = new Date(currentDateISO).getTime();
  const end = dataLimite.getTime();

  const diff = end - now;

  if (diff <= 0) {
    return {
      expired: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalMs: 0,
    };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return {
    expired: false,
    days,
    hours,
    minutes,
    seconds,
    totalMs: diff,
  };
}
